var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_vm._m(0),_c('div',{attrs:{"id":"container"},on:{"click":function($event){_vm.centerShow=false}}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box",attrs:{"id":"loading"}},[_c('div',{staticClass:"loader3"})])
}]

export { render, staticRenderFns }